import http from '../util/request.js'

export const payList = (params) =>{
	return http({
		url:'/apistore/pay/list',
		data:params,
		method:'get'
	})
}

export const getChannel = (params) =>{
	return http({
		url:'/apistore/pay/getChannel',
		data:params,
		method:'get'
	})
}
export const getkefu = (params) =>{
	return http({
		url:'/apistore/pay/getkefu',
		data:params,
		method:'get'
	})
}


export const addPay = (params) =>{
	return http({
		url:'/apistore/pay/add',
		data:params,
		method:'post'
	})
}
